/**
 * SmartphoneSkinKeyRegistry is a generic object which functions as sort of a dictionary, for storing smartphone SkinKey objects.
 * @see AbstractInstaller._mapMediator
 * @type {Object} 
 */
const SmartphoneSkinKeyRegistry = {};
export default SmartphoneSkinKeyRegistry;